import React from 'react';
import { motion } from 'framer-motion';
import { InstagramIcon, FacebookIcon } from 'lucide-react';
export function Footer() {
  const quickLinks = [{
    label: 'Inicio',
    href: '#inicio'
  }, {
    label: 'Nosotros',
    href: '#nosotros'
  }, {
    label: 'Productos',
    href: '#productos'
  }, {
    label: 'Mesas Dulces',
    href: '#mesas-dulces'
  }, {
    label: 'Catering',
    href: '#catering'
  }, {
    label: 'Galería',
    href: '#galeria'
  }, {
    label: 'Contacto',
    href: '#contacto'
  }];
  return <footer className="bg-secondary-brown text-white py-12" data-id="element-28">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-29">
        <div className="grid md:grid-cols-3 gap-12 mb-8" data-id="element-30">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} data-id="element-31">
            <div className="flex items-start mb-4" data-id="element-32">
              <img src="https://cdn.magicpatterns.com/uploads/9EoEQey3VZnyVTGdATLrNc/LOGOOOOO.png" alt="La Victoria II Logo" className="h-24 w-24 object-contain" data-id="element-33" />
            </div>
            <h3 className="font-script text-3xl text-primary-yellow mb-4" data-id="element-34">
              La Victoria II
            </h3>
            <p className="text-white/80 mb-4" data-id="element-35">
              Panadería artesanal con tradición, calidad y excelencia en cada
              producto.
            </p>
            <p className="text-primary-yellow font-serif italic" data-id="element-36">
              "Calidad y excelencia en cada sabor."
            </p>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.1
        }} data-id="element-37">
            <h4 className="text-xl font-semibold mb-4" data-id="element-38">Enlaces Rápidos</h4>
            <ul className="space-y-2" data-id="element-39">
              {quickLinks.map(link => <li key={link.href} data-id="element-40">
                  <a href={link.href} className="text-white/80 hover:text-primary-yellow transition-colors" data-id="element-41">
                    {link.label}
                  </a>
                </li>)}
            </ul>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.2
        }} data-id="element-42">
            <h4 className="text-xl font-semibold mb-4" data-id="element-43">Contacto</h4>
            <div className="space-y-3 text-white/80" data-id="element-44">
              <p data-id="element-45">San Martin 1090, San Luis</p>
              <p data-id="element-46">+54 9 2665 01-3601</p>
              <p data-id="element-47">Lun-Vie: 7:00 - 21:00</p>
              <p data-id="element-48">Sáb-Dom: 8:00 - 15:00</p>
            </div>
            <div className="flex space-x-4 mt-6" data-id="element-49">
              <a href="https://www.instagram.com/panaderialavictoria2?igsh=MWtyOHdmYnYxd2Nxbw==" target="_blank" rel="noopener noreferrer" className="bg-primary-yellow p-3 rounded-full hover:bg-primary-gold transition-colors" aria-label="Instagram" data-id="element-50">
                <InstagramIcon className="text-secondary-brown" size={20} data-id="element-51" />
              </a>
            </div>
          </motion.div>
        </div>

        <div className="border-t border-white/20 pt-8 text-center text-white/60" data-id="element-52">
          <p data-id="element-53">
            &copy; {new Date().getFullYear()} La Victoria II. Todos los derechos
            reservados.
          </p>
        </div>
      </div>
    </footer>;
}